<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    content-class="verifyTel"
  >
    <v-form ref="form">
      <v-stepper v-model="step">
        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <v-card class="px-12 py-8 text-caption">
              <v-btn small icon absolute right top @click="dialog = false">
                <v-icon small icon>fa-times</v-icon>
              </v-btn>
              <v-card-title class="justify-center font-weight-bold mb-6">手機驗證</v-card-title>
              手機號碼
              <v-text-field 
                outlined 
                dense 
                background-color="white" 
                :rules="[$rules.integer]" 
                v-model="tel"
                autofocus
                @keydown.enter="sendVerifyCode"
              ></v-text-field>
              <v-btn color="pink" dark block class="mt-6" @click="sendVerifyCode">取得驗證碼</v-btn>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="2" class="pa-0">
            <v-card class="py-8 px-10 verify">
              <h3 class="mb-6 text-center">手機驗證</h3>
              <div class="d-flex align-center mb-6">
                <v-icon class="mr-4">fa-phone-alt</v-icon>
                <div>請輸入 <span class="font-weight-bold">{{ tel }}</span> 收到的6位數驗證碼，驗證碼15分鐘內有效</div>
              </div>
              <span>手機驗證碼</span>
              <div class="code-input">
                <div v-for="n, i in 6">
                  <input 
                    :ref="`input${i}`" 
                    type="number"
                    @keydown="inputAction(i)" 
                    :autofocus="i === 0 ? true : false"
                    v-model="code[i]"
                  >
                </div>
              </div>
              <v-btn 
                block 
                class="pink white--text mb-2" 
                :disabled="code.join('').length != 6" 
                @click="verifyTel"
              >
                送出
              </v-btn>
              <a @click="!sending ? sendVerifyCode() : ''" :class="['resend', {'not-allow': sending}]">
                <span :class="sending ? 'grey-1--text' : 'pink--text'">重新發送驗證碼 </span>
                <span v-if="sending">({{ time }})</span>
                <v-icon v-else x-small color="pink" class="pl-2">fa-chevron-right</v-icon>
              </a>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ['tel'],
  data() {
    return {
      dialog: false,
      step: 1,
      code: Array(6).fill(''),
      sending: false,
      time: this.$resendTime,
    }
  },
  computed: {
    formIsValid() {
      return this.$rules.integer(this.tel) && this.$rules.notEmpty(this.code.join(''))
    },
  },
  watch: {
    dialog(newValue) {
      if(!newValue) {
        this.$refs.form.reset()
      }
    },
    code: {
      handler(newValue) {
        if(newValue.join('').length == 6) {
          this.verifyTel()
        }
      },
      deep: true
    }
  },
  methods: {
    input(i) {
      return this.$refs[`input${i}`][0]
    },
    startTimer() {
      this.sending = true
      var timer = setInterval(() => {
        this.time -= 1 
        if(this.time < 0) {
          clearInterval(timer)
          this.time = this.$resendTime
          this.sending = false
        }
      }, 1000)
    },
    sendVerifyCode() {
      if(!this.$rules.integer(this.tel)) {
        return
      }
      this.$store.dispatch('user/sendVerifyTel', this.tel).then(response => {
        this.$root.$emit('alert', 'success', '驗證碼已發送')
        this.step = 2
        this.startTimer()
        this.$nextTick(() => {
          this.code = Array(6).fill('')
          this.input(0).focus()
        })
      }).catch(e => {
        if(e.response) {
          let minute = e.response.data.message.match(/Try again after (\d+) minute/)
          if(minute) {
            this.$root.$emit('alert', 'error', `請${minute[minute.length - 1]}分鐘後再試`)
          }
          else if(e.response.data.message.includes('Please contact our customer service')) {
            this.$root.$emit('alert', 'error', '發送次數過多，請聯繫我們')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '發送失敗')
        }
      })
    },
    verifyTel() {
      if(!this.formIsValid) {
        return
      }
      this.axios.get(`/member/SMS/verify/register?code=${this.code.join('')}`).then(response => {
        this.$store.dispatch('user/getUserInformation')
        this.$root.$emit('alert', 'success', '驗證成功')
        this.dialog = false
      }).catch(e => {
        if(e.response) {
          if(e.response.data.message.includes('Code is wrong')) {
            this.$root.$emit('alert', 'error', '驗證碼錯誤')
          }
          else if(e.response.data.message.includes('Code is expired')) {
            this.$root.$emit('alert', 'error', '驗證碼已失效')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '驗證失敗')
        }
        this.code = Array(6).fill('')
        this.input(0).focus()
      })
    },
    inputAction(i) {
      if(this.$numeric.includes(event.keyCode) && this.code.join('').length >= i) {
        this.code.splice(i, 1, event.key)
        this.$nextTick(() => {
          if(this.code.join('').length != 6) {
            this.input(i + 1).focus()
          }
        })
      }
      else if(event.keyCode == 8) {
        if(this.code[i]) {
          this.code.splice(i, 1, '')
        }
        else if(this.code.join('').length) {
          this.code.splice(i - 1, 1, '')
          this.input(i - 1).focus()
        }
      }
      this.$forceUpdate()
      if(!this.$funcKeys.includes(event.keyCode)) {
        event.preventDefault()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.verifyTel {
  i {
    color: white !important;
  }
  .v-card {
    background-color: $grey-2;
    color: white;
    .code-input {
      input {
        color: white;
      }
    }
    .not-allow {
      cursor: not-allowed !important;
    }
  }
}
</style>